<template>
	<div class="row">
		<Dropzone @selected="setUploadedFile"/>
		<AvSelector @selected="setSelectedAVs"/>
	</div>
	<div class="upload-details">
		<h4>Supported Formats: </h4>
		<div>Windows Executable Files (PE) - exe, .dll, .sys - native x86. native x64 and .NET.</div>
		<div>Linux Executable Files (ELF) - native x86, native x64, ARM32, ARM64</div>
	</div>
	<div class="av-checkbox bounce" style="display:flex; margin:0">
		<input type="checkbox" id="checkbox-private"
		/>
		<svg viewBox="0 0 21 21">
			<polyline points="5 10.75 8.5 14.25 16 6"></polyline>
		</svg>
		<label for="checkbox-private">
			Private Scan
		</label>
	</div>
	<div class="btn-submit">
		<button @click="upload" :disabled="disabled">Submit</button>
	</div>
</template>

<script>

import Dropzone from '@/components/Actions/Upload/Dropzone.vue'
import AvSelector from '@/components/Actions/Upload/AvSelector.vue'
// import axios from 'axios'

export default {
	name: 'Upload',
	emits: ["submitted"],
	components: { 
		Dropzone,
		AvSelector
	},
	data() {
		return {
			selectedAVs: [],
			file: null,
			disabled: false,
		}
	},
	methods: {
		setSelectedAVs(value) {
			this.selectedAVs = value
		},
		setUploadedFile(value) {
			this.disabled = false
			this.file = value
		},
		upload() {
			this.disabled = true
			this.$emit('submitted', {file: this.file, avs: this.selectedAVs})
		}
	}
}
</script>